import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, apiErr } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/auth/forgot-password", { email }); setSent(true); }
    catch (err) { toast.error(apiErr(err)); }
    finally { setBusy(false); }
  };
  return (
    <AuthShell title="Reset Password" sub="We'll send a secure reset link.">
      {sent ? (
        <div data-testid="forgot-sent"><p className="text-slate-600">If that account exists, a reset link has been sent. Check your email.</p><Link to="/login" className="text-turquoise font-semibold mt-4 inline-block">Back to login</Link></div>
      ) : (
        <form onSubmit={submit} className="space-y-4">
          <div><Label>Email</Label><Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" className="rounded-xl" /></div>
          <Button type="submit" disabled={busy} className="w-full bg-navy rounded-full font-bold" data-testid="forgot-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Send Reset Link"}</Button>
          <Link to="/login" className="text-turquoise text-sm block text-center">Back to login</Link>
        </form>
      )}
    </AuthShell>
  );
}

export function ResetPassword() {
  const [params] = useSearchParams();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const invite = params.get("invite") === "1";  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token: params.get("token"), password });
      toast.success(invite ? "You're all set! Log in with your email and new password." : "Password updated! Please log in.");
      nav("/login");
    } catch (err) { toast.error(apiErr(err)); }
    finally { setBusy(false); }
  };
  return (
    <AuthShell title={invite ? "Welcome to Adventure Rock!" : "Set New Password"} sub={invite ? "Your parent account is ready. Choose a password to claim it." : "Choose a new password for your account."}>
      <form onSubmit={submit} className="space-y-4">
        <div><Label>{invite ? "Create password" : "New password"}</Label><Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} data-testid="reset-password" className="rounded-xl" /></div>
        <Button type="submit" disabled={busy} className="w-full bg-navy rounded-full font-bold" data-testid="reset-submit">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : invite ? "Claim My Account" : "Update Password"}</Button>
      </form>
    </AuthShell>
  );
}
